<template>
  <div id="SectionFooter">
    <ul>
      <li class="copyright">
        준법감시인 심의필 2022-2-002호(2022.05.19)
      </li>
      <li class="copyright">
      Copyright © FUNDA 2020. All Right Reserved.
      </li>
      <li class="content">
        <b>(주)펀다 대표 박성준</b><br />
      </li>
      <li class="content">
        <span><b>서울 서초구 사평대로53길 30 메이크잇 203호 ,204호</b></span><br />
      </li>
      <li class="content">
        <b>사업자등록번호 : 724-87-00107<br />
        통신판매업 : 2019-서울강남-05110<br/>
        온라인투자연계금융업 등록번호 : 2022-18</b><br/>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SectionFooter',
}
</script>

<style lang="scss" scoped>
#SectionFooter {
  display: block;
  float: left;
  padding-top: 40px;
  padding-bottom: 133px;
  padding-left: 3.82vw;
  background-color: #f5f5f5;
  ul {
    width: 100%;
    float: left;
    padding: 0;
    margin: 0;
    li {
      display: block;
      float: left;
      width: 100%;
      margin-bottom: 18px;
    }
  }

  .content {
    display: block;
    float: left;
    font-size: 13px;
    line-height: 1.43;
    letter-spacing: -0.27px;
    color: #727d8c;
    b {
      font-weight: 700;
    }
    span {
      letter-spacing: -0.9px;
    }
  }

  .copyright {
    font-size: 13px;
    line-height: 1.54;
    color: #727d8c;
    margin-top: 5px;
  }
}
</style>
